import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { IThirdPartyLineOfBusiness, IThirdPartySearchCompany } from '@ruby/modules/third-party/models/third-party.interface';

@Component({
  selector: 'ng-third-party-contract',
  templateUrl: './third-contract.component.html',
  styleUrls: ['./third-contract.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThirdContractComponent implements OnChanges {
  @Input() customerCompany?: ICustomer;
  @Input() providerCompany?: IThirdPartySearchCompany;
  @Input() authStatus!: boolean;
  @Input() stepIndex!: number;
  @Input() isDoneEnabled!: boolean;
  @Input() isEdit!: boolean;
  @Input() lineOfBusiness!: Array<IThirdPartyLineOfBusiness>;
  @ViewChild('stepper') stepper!: MatStepper;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.stepIndex && changes.stepIndex.currentValue === 1 && this.stepper && !this.isEdit) {
      this.stepper.next();
    }
  }
}
